module.exports = __webpack_public_path__ + "img/2banner2.9bd58584.jpg";